import { useCallback, useEffect, useState } from "react";
import { Spin } from "antd";

import { Wrapper } from "./styles";
import { useParams } from "react-router-dom";
import { FichaService } from "../../services/ficha.service";
import { DetailsAddress } from "../details/address";
import { DetailsUser } from "../details/user";
import { DetailsSystem } from "../details/system";
import { DetailsHigher } from "../details/higher";
import { DetailsComissaoSip3w } from "../details/comissaoSip3w";
import { DetailsInteligencia } from "../details/inteligencia";
import { DetailsFiles } from "../details/files";
import { DetailsSecretarioExecutivo } from "../details/secretarioExecutivo";
import { toast } from "react-toastify";
import { Row, Col, Button, Popconfirm, Modal } from "antd";

export default function ViewFichaCompleta() {
  const { id } = useParams();

  const [state, setState] = useState({
    cpf: "",
    nivel: null,
    observacao: null,
    matricula: null,
    nome: null,
    loading: true,
    entidade: {},
  });

  const update = useCallback((value) => {
    setState((prev) => ({ ...prev, ...value }));
  }, []);

  const loadById = useCallback(async () => {
    update({ loading: true });

    try {
      const { data } = await FichaService.getById({ id });
      update({ loading: false, entidade: data, nivel: data.nivel });
    } catch (err) {
      console.log(err);
    }
  }, [update, id]);

  useEffect(() => {
    loadById();
  }, [loadById]);

  const { entidade } = state;

  const reenviarFicha = useCallback(
    async (isAprovado) => {
      try {
        await FichaService.resendEmail(id);
        countDown(isAprovado);
      } catch (err) {
        toast.error("Erro ao tentar reenviar a ficha, tente novamente!");
      }
    },
    [id]
  );

  function countDown(isAprovado) {
    const totalSeconds = 5;
    let secondsToGo = totalSeconds;

    const modal = Modal.success({
      title: `Ficha reenviada com sucesso`,
      content: ``,
    });
    const timer = setInterval(() => {
      secondsToGo -= 1;

      if (secondsToGo > 0) {
        modal.update({
          content: `A modal será fechada em ${secondsToGo} segundos.`,
        });
      } else {
        clearInterval(timer);
        modal.destroy();
      }
    }, 1000);
  }

  return (
    <Spin spinning={state.loading}>
      <Wrapper>
        <DetailsUser entidade={entidade} />
        <br />
        <DetailsAddress entidade={entidade} />
        <br />
        <DetailsSystem entidade={entidade} />
        <br />
        <DetailsHigher entidade={entidade} />
        <br />
        <DetailsComissaoSip3w entidade={entidade} />
        <br />
        <DetailsInteligencia entidade={entidade} />
        <br />
        <DetailsSecretarioExecutivo entidade={entidade} />
        <br />
        <DetailsFiles entidade={entidade} />
        <br />
        <br />
        <br />
        <Row justify="end">
          <Col span={2} pull={1}>
            {entidade?.statusAutorizacaoChefeImediato !== "APROVADO" && (
              <Popconfirm
                placement="top"
                title={"Deseja realmente reenviar?"}
                onConfirm={() => reenviarFicha(true)}
                okText="Sim"
                cancelText="Não"
              >
                <Button type="primary">Reenviar Ficha</Button>
              </Popconfirm>
            )}
          </Col>
        </Row>
        <br />
      </Wrapper>
    </Spin>
  );
}

